import { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Tooltip,
} from "@mui/material";
import { toast } from "react-toastify";
import EditIcon from "@mui/icons-material/EditOutlined";
import { useChecklistContext } from "context/ChecklistContext";
import { useEditChecklistMutation } from "app/api/checklists";

const EditRoomName: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const { checklist } = useChecklistContext();
  const [newRoomName, setNewRoomName] = useState("");
  const [editChecklist, { isLoading }] = useEditChecklistMutation();

  useEffect(() => {
    if (checklist) setNewRoomName(checklist.roomName);
  }, [checklist]);

  const handleClick = () => {
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const handleSave = async () => {
    if (!checklist) return;

    editChecklist({ id: checklist.id, roomName: newRoomName })
      .unwrap()
      .then(() => {
        toast.success("Namnet på checklistan redigerades!", {
          autoClose: 3000,
          hideProgressBar: true,
        });
      })
      .catch(() => {
        toast.error("Något gick fel när namnet skulle redigeras.", {
          autoClose: 3000,
          hideProgressBar: true,
        });
      });
    handleClose();
  };

  return (
    <>
      <Tooltip arrow title="Ändra namn">
        <IconButton onClick={handleClick}>
          <EditIcon />
        </IconButton>
      </Tooltip>

      <Dialog open={showModal} onClose={handleClose}>
        <DialogTitle>Redigera namn på rum/checklista</DialogTitle>

        <DialogContent dividers>
          <TextField
            type="text"
            variant="filled"
            label="Nytt namn"
            autoFocus
            fullWidth
            value={newRoomName}
            onChange={(e) => setNewRoomName(e.target.value)}
          />
        </DialogContent>

        <DialogActions>
          <Button variant="outlined" onClick={handleClose} className="me-2" disabled={isLoading}>
            Avbryt
          </Button>
          <Button
            disabled={newRoomName === ""}
            variant="contained"
            onClick={handleSave}
            loading={isLoading}
          >
            Spara
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default EditRoomName;
